import { Button } from '../../../../../components/ui/button'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../../components/ui/alert-dialog'
import { useRemoveTeamController } from './useRemoveTeamController'
import { MinusCirlce } from 'iconsax-react'

export const RemoveTeam = ({ id }: { id: string }) => {
  const { handleRemoveTeam, isPending } = useRemoveTeamController()

  return (
    <div>
      <AlertDialog>
        <AlertDialogTrigger
          asChild
          onClick={(event) => event.stopPropagation()}
        >
          <MinusCirlce className="absolute right-3 top-3 text-error" />
        </AlertDialogTrigger>
        <AlertDialogContent className="w-96">
          <form
            onClick={(event) => event.stopPropagation()}
            onSubmit={(event) => handleRemoveTeam(event, id)}
          >
            <AlertDialogHeader>
              <AlertDialogTitle>
                Você quer realmente remover essa equipe?
              </AlertDialogTitle>
            </AlertDialogHeader>
            <AlertDialogFooter className="flex items-center">
              <AlertDialogCancel>Cancelar</AlertDialogCancel>
              <AlertDialogAction asChild>
                <Button
                  type="submit"
                  disabled={isPending}
                  className="my-4 bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
                >
                  Remover
                </Button>
              </AlertDialogAction>
            </AlertDialogFooter>
          </form>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  )
}
